import React from "react";
import {
  HeroContentPostDownloadBackground,
  HeroContentPostDownloadBase,
  Text,
  Title,
  Subtitle,
  BreadcrumbsWrapper,
  FormTitle,
  FormSubtitle,
  Form,
  HeroText,
  ImageClassName,
} from "./hero-content-post-download.styled";
import {
  HeroContentPostFragment,
  ContentCategoryFragment,
  ContentHubFragment,
} from "../../types/graphql";
import { linkTo } from "../../utils/contentUtils";
import { PrismicRichText } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import HubSpotForm from "../hubspot-form/hubspot-form";
import { GatsbyImage } from "gatsby-plugin-image";
import { ClassNames } from "@emotion/react";
import Breadcrumbs, { BreadCrumbProps } from "../breadcrumbs/breadcrumbs";

interface IHeroContentPostDownloadProps {
  heroContentPost: HeroContentPostFragment;
  breadcrumbs: BreadCrumbProps[];
}

const HeroContentPostDownload = (props: IHeroContentPostDownloadProps) => {
  const {
    heroContentPost: { data: hero },
    breadcrumbs,
  } = props;

  return (
    (hero && (
      <HeroContentPostDownloadBackground>
        <HeroContentPostDownloadBase>
          <HeroText>
            <BreadcrumbsWrapper>
              <Breadcrumbs breadcrumbs={breadcrumbs} />
            </BreadcrumbsWrapper>
            <Text>
              {hero.title && <Title>{hero.title}</Title>}
              {hero.subtitle && <Subtitle>{hero.subtitle}</Subtitle>}
            </Text>
          </HeroText>
          <Form>
            {hero.form_title && <FormTitle>{hero.form_title}</FormTitle>}
            <ClassNames>
              {({ css, cx }) =>
                hero.image?.gatsbyImageData && (
                  <GatsbyImage
                    image={hero.image.gatsbyImageData}
                    alt={hero.image.alt || "Xometry Image"}
                    className={css(ImageClassName)}
                  />
                )
              }
            </ClassNames>
            {hero.form_subtitle && (
              <FormSubtitle>
                <PrismicRichText
                  field={hero.form_subtitle.richText}
                  components={htmlSerializer}
                />
              </FormSubtitle>
            )}
            {hero.hubspot_form_id && (
              <HubSpotForm hubSpotFormID={hero.hubspot_form_id} />
            )}
          </Form>
        </HeroContentPostDownloadBase>
      </HeroContentPostDownloadBackground>
    )) || <></>
  );
};

export default HeroContentPostDownload;
